define((require) => {
    "use strict";

    const _                   = require("underscore");
    const AbstractWidgetModel = require("shared/ui/experience/widgets/AbstractWidgetModel");

    const DEFAULT_HTML_HEIGHT_PERCENTAGE = 50;
    const DEFAULT_HTML_WIDTH_PERCENTAGE = 50;

    /**
     * Model for the html widget.
     *
     * @class HTMLWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("HTMLWidget", {

        defaults: _.defaults({
            type: "html",
            width: DEFAULT_HTML_HEIGHT_PERCENTAGE,
            height: DEFAULT_HTML_WIDTH_PERCENTAGE,
            htmlText: ""
        }, AbstractWidgetModel.prototype.defaults)

    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/htmlWidget/HTMLWidgetModel.js